import * as React from 'react';
import { FC } from 'react';

import { useLoyaltyContext } from 'state/loyalty';
import { removeAppliedRewardsInStorage } from 'state/loyalty/hooks/use-loyalty-rewards';
import {
  ShortCodeState,
  useInRestaurantRedemptionContext,
} from 'state/loyalty/in-restaurant-redemption';

import ShortCodeConfirmationModal from '../loyalty-short-code-confirmation-modal';

export const InRestaurantRedemptionDialogStatus: FC = () => {
  const { resetLoyaltyRewardState, refetchLoyaltyUser } = useLoyaltyContext();
  const { resetInRestaurantRedemption, shortCodeState } = useInRestaurantRedemptionContext();

  const onAction = () => {
    resetInRestaurantRedemption();
    resetLoyaltyRewardState();
    removeAppliedRewardsInStorage();
    refetchLoyaltyUser();
  };

  return shortCodeState === ShortCodeState.Claimed ? (
    <ShortCodeConfirmationModal onAction={onAction} />
  ) : null;
};
